export default __webpack_public_path__ + "static/media/contact-me.8d8d77c2.svg";